import { render, staticRenderFns } from "./Distribuidoras.vue?vue&type=template&id=480fa8bc"
import script from "./Distribuidoras.vue?vue&type=script&lang=js"
export * from "./Distribuidoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports